var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentRoute === 'home')?_c('img',{staticClass:"absolute bottom-0 z-10 hlg:mb-3 w-full",attrs:{"src":require("@/assets/images/bg-wave.svg"),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }